import { takeLatest, put, call } from 'redux-saga/effects';
import LoginTypes from './login.types';
import { login } from './login.services';
import { loginSuccess, loginFailure } from './login.action';
import { encryptData } from '../_common/enode-decode';

export function* loginSaga(payload: any) {
	try {
		const LoginDetailsToken = {
			userPhone: payload.payload.userPhone,
			userPassword: payload.payload.userPassword,
		};
		const encryptedData = encryptData(LoginDetailsToken, LoginTypes.LOGIN_KEY);
		// @ts-ignore
		const responseData = yield call(login as any, encryptedData);
		if (responseData.data.status === 'success') {
			yield put(loginSuccess(responseData.data));
		} else {
			yield put(loginFailure(responseData.data));
		}
	} catch (error: any) {
		yield put(loginFailure(error?.response?.data?.message || 'An error occurred'));
	}
}

export function* onLoginStart(): Generator<any, void, any> {
	yield takeLatest(LoginTypes.LOGIN_START as any, loginSaga);
}

export function* loginSagaDetails(): Generator<any, void, any> {
	yield call(onLoginStart);
}
